import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Common/Footer';
import RightSideBar from './RightSideBar';
import { useTheme } from '../DataStore/ThemeContext';
import SuccessDialog from './Common/SuccessDialog';

const PageContainer = (props) => {
  const { settingsOpen, closeSettings, settingTitle, settingCode, settingData, clearSweetDialogInfo, sweetDialogInfo } = useTheme();

  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Default open for web
  const [isMobileHeaderOpen, setIsMobileHeaderOpen] = useState(false);
  const [isWebView, setIsWebView] = useState(true); // Assume web view initially
  

  // Update `isWebView` based on window width
  useEffect(() => {
    const handleResize = () => {
      setIsWebView(window.innerWidth > 768); // Web view if width > 768px
    };

    handleResize(); // Check on initial render
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Toggle sidebar state
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Toggle mobile header state
  const toggleMobileHeader = () => {
    setIsMobileHeaderOpen(!isMobileHeaderOpen);
  };

  // Determine dynamic class
  const containerClass = [
    'app-container',
    'app-theme-white',
    'body-tabs-shadow',
    'fixed-header',
    'fixed-sidebar',
    isSidebarOpen ? '' : 'closed-sidebar',
    !isWebView && isSidebarOpen ? 'sidebar-mobile-open' : '',
    !isWebView && !isSidebarOpen ? 'closed-sidebar-mobile' : ''
  ]
    .filter(Boolean) // Remove empty strings
    .join(' ');

  return (
    <>
    <div className={containerClass}>
      <Header
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        mobileHeaderIsOpen={isMobileHeaderOpen}
        toggleMobileHeader={toggleMobileHeader}
      />
      <div className="app-main">
        <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="app-main__outer">
          {props.children}
          <Footer />
        </div>
      </div>
      <RightSideBar
        settingsOpen={settingsOpen}
        closeSettings={closeSettings}
        settingTitle={settingTitle}
        settingCode={settingCode}
        settingData={settingData}
      />
    </div>
    <SuccessDialog
        show={sweetDialogInfo? true : false}
        onClose={clearSweetDialogInfo}
        message={sweetDialogInfo?.title}
        details={sweetDialogInfo?.subtitle}
  />
    </>
  );
};

export default PageContainer;
